export default __webpack_public_path__ + "static/media/app-strore-full.cf8cf976.svg";